export const PHONECODENOTRECEIVED = "Didn't recieve the code on phone?";
export const MAILCODENOTRECEIVED = "Didn't recieve the code on mail?";
export const RESENDTIMER = "You can resend OTP after timer ends";
export const CODENOTRECEIVED = "Didn't receive the code?";
export const DURATION = 30;
